import Card from '@/models/Card/card';
import consts from '@/consts';

export default class Lineup {
  constructor({
    formation = null,
    captain = null,
    averageScoreSum = null,
    goalkeepersCard = [],
    defendersCard = [],
    midfieldersCard = [],
    forwardsCard = [],
  } = {}) {
    this.formation = formation ?? '3-4-3';
    this.captain = captain;
    this.averageScoreSum = averageScoreSum;
    this.goalkeepersCard = goalkeepersCard.map(
      (goalkeeperCard) => Card.createFromObject(goalkeeperCard),
    );
    this.defendersCard = defendersCard.map(
      (defenderCard) => Card.createFromObject(defenderCard),
    );
    this.midfieldersCard = midfieldersCard.map(
      (midfielderCard) => Card.createFromObject(midfielderCard),
    );
    this.forwardsCard = forwardsCard.map(
      (forwardCard) => Card.createFromObject(forwardCard),
    );
  }

  reset() {
    this.captain = null;
    this.averageScoreSum = null;
    this.goalkeepersCard = [];
    this.defendersCard = [];
    this.midfieldersCard = [];
    this.forwardsCard = [];
  }

  defendersCount() {
    const defendersCount = this.formation?.split('-')[0];

    return defendersCount ? parseInt(defendersCount, 10) : 0;
  }

  midfieldersCount() {
    const midfieldersCount = this.formation?.split('-')[1];

    return midfieldersCount ? parseInt(midfieldersCount, 10) : 0;
  }

  forwardsCount() {
    const forwardsCount = this.formation?.split('-')[2];

    return forwardsCount ? parseInt(forwardsCount, 10) : 0;
  }

  totalScore() {
    let total = 0;
    this.getCards().forEach((card) => {
      const score = card.totalScore;
      total += this.captain === card.slug ? ((score ?? 0) * 1.5) : (score ?? 0);
    });

    return total;
  }

  getCards() {
    return this.goalkeepersCard
      .concat(this.defendersCard, this.midfieldersCard, this.forwardsCard)
      .filter(card => card !== undefined);
  }

  isSet() {
    return this.getCards().length > 0;
  }

  static createFromObject(data) {
    return new Lineup(data);
  }

  serialize() {
    return {
      formation: this.formation,
      captain: this.captain,
      averageScoreSum: this.averageScoreSum,
      goalkeepers: this.goalkeepersCard.map((goalkeeperCard) => goalkeeperCard.slug),
      defenders: this.defendersCard.map((defenderCard) => defenderCard.slug),
      midfielders: this.midfieldersCard.map((midfielderCard) => midfielderCard.slug),
      forwards: this.forwardsCard.map((forwardCard) => forwardCard.slug),
    };
  }
}
